<app-toast></app-toast>
<h1 class="text-4xl font-bold mobile:text-lg">{{ 'auth.onboarding_step_3.help_us_customize' | transloco}}</h1>
<p class="mt-1 text-neutral-500 mobile:text-sm">{{ 'auth.onboarding_step_3.neox_is_your_one_stop' | transloco}}</p>
<p class="mt-1 text-neutral-500 mobile:text-sm"><b>{{ 'auth.onboarding_step_3.help_us_indicating' | transloco}}</b>
</p>

<h2 class="mt-[2vh] font-bold mobile:text-sm">{{ 'auth.onboarding_step_3.energy_management' | transloco}}</h2>
<div class="flex w-full flex-wrap gap-4 mt-2 mobile:text-xs">
    <div class="h-[50px] w-auto" *ngFor="let option of options.slice(0, 4)">
        <app-custom-radio-button [(state)]="option.checked" [buttonText]="option.name"></app-custom-radio-button>
    </div>
</div>

<h2 class="mt-[2vh] font-bold mobile:text-sm">{{ 'auth.onboarding_step_3.cost_optimization' | transloco}}</h2>
<div class="flex w-full flex-wrap gap-4 mt-2 mobile:text-xs">
    <div class="h-[50px] w-auto" *ngFor="let option of options.slice(4, 6)">
        <app-custom-radio-button [(state)]="option.checked" [buttonText]="option.name"></app-custom-radio-button>
    </div>
</div>

<h2 class="mt-[2vh] font-bold mobile:text-sm">{{ 'auth.onboarding_step_3.esg' | transloco}}</h2>
<div class="flex w-full flex-wrap gap-4 mt-2 mobile:text-xs">
    <div class="h-[50px] w-auto" *ngFor="let option of options.slice(6, 9)">
        <app-custom-radio-button [(state)]="option.checked" [buttonText]="option.name"></app-custom-radio-button>
    </div>
</div>

<div class="form-control w-[250px] mt-4 mobile:text-sm">
    <label class="cursor-pointer label">
        <input type="checkbox" checked="checked" [(ngModel)]="selectAllButton" (change)="toggleSelectAll()"
            class="checkbox border-border [--chkbg:theme(colors.primary.1000)] [--chkfg:theme(colors.white)] checked:border-primary" />


        <span>{{ 'auth.onboarding_step_3.all_interesting' | transloco}}</span>
    </label>
</div>

<div class="max-w-screen-sm w-full mt-8 mb-6">
    <app-primary-button buttonText="{{ 'shared.continue' | transloco}}" [isDisabled]="continueClicked" (buttonClick)="continueButtonClick()">
    </app-primary-button>
</div>